<template>
  <div class="container">
    <scroll
      :data="emptyShopList"
      :allLoaded="noMore"
      @pulldown="loadData"
      @loadUp="loadup"
      v-if="emptyShopList.length"
    >
      <div
        v-for="(item,index) in emptyShopList"
        :key="index"
        class="list_item"
        @click="toEmptyDetail(item.id)"
      >
        <div class="item_top">
          <div class="top_left">
            <img class="top_left_icon" src="../../assets/images/empty_bg.jpg" />
            <img v-if="item.smallUrl" class="top_left_icon" :src="item.smallUrl" />
          </div>
          <div class="top_right">
            <p class="title">{{item.title}}</p>
            <p class="area">面积：{{item.jzmj}}㎡</p>
            <p class="adress over_two_lines">地址：{{item.address}}</p>
          </div>
        </div>
        <div class="item_bottom">
          <div class="bottom_left">
            <img class="bottom_left_icon" src="../../assets/images/see.png" />
            <p class="bottom_left_text">{{item.viewNum}}人围观</p>
          </div>
          <div class="bottom_right">
            <p
              class="bottom_right_text"
              v-for="(cur,j) in item.label"
              :key="cur"
              v-if="j<2"
            ># {{cur}}</p>
          </div>
        </div>
      </div>
    </scroll>
    <div class="no_mess" v-if="!emptyShopList.length && loaded">
      <no-message></no-message>
    </div>
  </div>
</template>

<script>
import util from "../../utils/util";
import { mapState } from "vuex";
import { getVacantShopByMarketId } from "../../utils/api";
import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
export default {
  name: "emptyShopList",
  data() {
    return {
      pageNo: 1,
      noMore: false,
      loaded: false,
      emptyShopList: []
    };
  },
  components: {
    NoMessage,
    Scroll
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.getVacantShopByMarketId();
  },
  methods: {
    // 上拉加载
    loadup() {
      if (this.noMore) {
        return;
      }
      this.pageNo++;
      this.getVacantShopByMarketId();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      this.getVacantShopByMarketId();
    },
    getVacantShopByMarketId() {
      util.showLoading();
      let params = {
        pageNo: this.pageNo,
        marketId: this.common.marketInfo.id,
        pageSize: 10
      };
      getVacantShopByMarketId(params).then(res => {
        console.log(res);
        this.loaded = true;
        util.hideLoading();
        if (res.res.code === 10000) {
          let data = res.body.vacantShopList;
          if (data.length != 10) {
            this.noMore = true;
          }
          data.forEach(item => {
            if (item.label) {
              item.label = item.label.split(",");
            }
          });
          if (this.pageNo === 1) {
            this.emptyShopList = data;
          } else {
            this.emptyShopList = [...this.emptyShopList, ...data];
          }
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    toEmptyDetail(id){
      if (!this.$store.state.common.userId) {
          this.$router.push({
            path:'/login',
            query:{
              Rurl:`/emptyShopDetail?id=${id}`
            }
          });
      }else{
        this.$router.push(`/emptyShopDetail?id=${id}`)
      }

    },
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background-color: @colore;
  height:100vh;
}
.list_item {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 20px;
  margin: 20px 20px 0;
}

.item_top {
  margin-bottom: 28px;
  display: flex;
  flex-direction: row;
}

.item_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height:36px;
  align-items: center;
}

.bottom_left,
.bottom_right {
  display: flex;
  flex-direction: row;
}

.bottom_right {
  flex: 1;
  overflow: hidden;
  .flex();
  justify-content: flex-end;
}

.bottom_left_icon {
  height: 32px;
  width: 32px;
  margin-right: 14px;
}

.bottom_left_text {
  height: 32px;
  text-align: left;
  line-height: 32px;
  font-size: 24px;
  color: #999999;
}

.bottom_right_text {
  height: 36px;
  background-color: rgba(235, 239, 245, 1);
  border-radius: 4px;
  padding: 0 8px;
  font-size: 24px;
  color: rgba(60, 100, 159, 1);
  line-height: 36px;
  margin-right: 10px;
}

.top_left {
  position: relative;
  width: 240px;
  height: 180px;
  margin-right: 20px;
}
.top_right {
  flex: 1;
}

.top_left_icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 240px;
  height: 180px;
}

.title,
.area {
  height: 40px;
  text-align: left;
  color: #333333;
  line-height: 40px;
  font-size: 28px;
  margin-bottom: 10px;
  .textOver(400px);
}
.title {
  font-weight: bold;
}

.area {
  font-size: 24px;
  height: 28px;
  line-height: 28px;
  color: #999999;
}

.adress {
  text-align: left;
  color: #999999;
  line-height:34px;
  font-size: 24px;
  margin-bottom: 10px;
}
.no_mess {
  height: 100vh;
  .flex();
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>